import { t } from '@lingui/macro';

export const PLM_ID_FIELD = 'id';

export const BASE_URL = '/api/v3/plms/';

export const PLM_NAME_FIELD = 'name';
export const PLM_AUTO_ACCESS = 'autoAccess';
export const PLM_HOST_FIELD = 'host';
export const PLM_SECRET_FIELD = 'secret';
export const PLM_DESCRIPTION_FIELD = 'description';
export const PLM_CREATED_AT_FIELD = 'createdAt';
export const PLM_UPDATED_AT_FIELD = 'updatedAt';
export const UNCHANGED_SECRET = '********';

// labels
export const PLM_PAGE_TITLE = t`Local Managers`;
export const PLM_UI_LABEL = t`Local Manager`;
export const PLM_SECRET_HELP = t`Use an API Token with a System Admin role generated on the Local Manager`;
